import {
  getApiEndpointUrl,
  getLpApiEndpointUrl,
} from "../configs/EnvironmentConfig";

/** Always reads current localStorage (after setBaseUrl). */
export const getApiBaseUrl = () => getApiEndpointUrl();
export const getLpApiBaseUrl = () => getLpApiEndpointUrl();

/**
 * Lazy string-like values so `${API_BASE_URL}path` works after URLs are loaded.
 * Prefer getApiBaseUrl() for new code.
 */
const createLazyUrl = (getter) => ({
  toString: () => getter() || "",
  valueOf: () => getter() || "",
  [Symbol.toPrimitive]: () => getter() || "",
});

export const API_BASE_URL = createLazyUrl(getApiBaseUrl);
export const LP_API_BASE_URL = createLazyUrl(getLpApiBaseUrl);
